import _ from 'lodash'
import { withCompInfo } from '../../core/withCompInfo'
import { StripSlideshowDefinition, StripSlideshowProps, StripSlideshowCarmiData } from './types'
import { getCompStyles, getUrl } from '../../tpaGallery'

const compStyleKeys = {
	titleColor: 'color1',
	descriptionColor: 'color2',
	backgroundColor: 'color3',
}

export const props = withCompInfo<StripSlideshowProps, StripSlideshowDefinition, StripSlideshowCarmiData>(
	[
		'compId',
		'compProps',
		'compLayout',
		'styleProperties',
		'viewMode',
		'language',
		'topology',
		'mainPageId',
		'globalImageQuality',
		'siteColors',
	],
	(
		{
			compId,
			compProps,
			compLayout,
			styleProperties,
			viewMode,
			language,
			topology,
			mainPageId,
			globalImageQuality,
			siteColors,
		},
		carmiProps
	) => {
		const { images } = carmiProps
		const santaBase = '1.11003.0' // TODO
		return {
			componentReady: false,
			currentIndex: 0,
			height: compLayout.height,
			isScreenWidth: true,
			compStyles: getCompStyles(compStyleKeys, styleProperties, siteColors),
			images,
			url: getUrl(
				`${topology.scriptsUrl}/services/santa/${santaBase}/node_modules/santa-galleries/target/StripSlideshow/StripSlideshow.html`,
				compId,
				viewMode,
				language
			),
			quality: _.pick(globalImageQuality, 'unsharpMask'),
			mainPageId,
			compProps,
		}
	}
)
